export default __webpack_public_path__ + "static/media/chevron-left.ef53982a.svg";